import { ApiCurrency } from "@incendium/api";
import currencyData from "./currencys.json";

export const getCurrencySymbol = (currecyCode: ApiCurrency) =>
  currencyData[currecyCode] ? currencyData[currecyCode].symbol : "$";
